import { render } from "./QAQCField.vue?vue&type=template&id=3a62b3b8&scoped=true"
import script from "./QAQCField.vue?vue&type=script&lang=js"
export * from "./QAQCField.vue?vue&type=script&lang=js"

import "./QAQCField.vue?vue&type=style&index=0&id=3a62b3b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a62b3b8"]])

export default __exports__